import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import swal from 'sweetalert';
import './Contact.css';



const Contact = () => {
    const [result, setResult] = useState(false);
    const sendEmail = e => {
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_p1vu72e', e.target, 'user_K3LSDQL8US3F3WLGBlnT1')
        if (result) {
            swal({
                title: "Congrats!",
                text: "Message Sent Successfully",
                icon: "success",
                button: "Ok!",
            });
        }
        e.target.reset();
        setResult(true);
    }

    return (
        <Container id="contact" className="contact-form">
            <form onSubmit={sendEmail}>
                <p style={{ color: "#64FFDA" }}>What's next?</p>
                <h1 style={{ color: "#CCD6F6", fontWeight: "bold" }}>Get In Touch</h1>
                <p style={{ color: "#8892B0", width: "50%", margin: "auto" }}>I am looking for new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you!</p>
                <div className="w-50 m-auto my-4 py-5" style={{ backgroundColor: "#112240", borderRadius: "5px" }}>
                    <div className="mb-4 w-30">
                        <div className="w-75 m-auto">
                            <input name="from_name" type="text" placeholder="Name" className="form-control input" required />
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="w-75 m-auto">
                            <input name="to-name" type="email" placeholder="Email" className="form-control input" required />
                        </div>
                    </div>
                    <div className="mb-4">
                        <div className="w-75 m-auto">
                            <input style={{ height: "100px" }} name="message" type="text" placeholder="Message" className="form-control input" />
                        </div>
                    </div>
                    <button className="custom-button" style={{ marginTop: "0px", textDecoration: "none" }} type="submit" >Send</button>
                </div>
            </form>

        </Container>

    );
};

export default Contact;